module.exports = __webpack_public_path__ + "static/media/zocalo3.3ee5e6be.jpg";